import React from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import * as agent from "../agent";
import { required } from "../utility";
import { CLIENT_LOADED, CONTRACT_UPDATED } from "../constants/actionTypes";
import { normalizeMoney } from "../utility";
import { MaterialTextField } from "./MaterialInput";
import Paper from '@material-ui/core/Paper';
import SubmitButton from './SubmitButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const tradeContract = ({carId, contractId, isBankrupt, onTradeSubmit, onContractBankrupt, handleSubmit}) => {
    const prepareData = data => Object.assign(data, { "preliminarySum": Number(data.preliminarySum.replace(/\s/g,``)) });
    return (
        <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
            <form className="common-form common-column" onSubmit={handleSubmit(data => onTradeSubmit(carId, prepareData(data)))}>
                <FormControlLabel
                    control={
                        <Checkbox
                          checked={isBankrupt}
                          onChange={() => onContractBankrupt(contractId, !isBankrupt)} />
                    }
                    label="Дефолт" />
                <Field component={MaterialTextField}
                       normalize={normalizeMoney}
                       validate={required}
                       endAdornment="₽"
                       name="preliminarySum"
                       label="Сумма продажи" />
                <Field component={MaterialTextField}
                       validate={required}
                       label="Ссылка на объявление"
                       name="tradeLink" />
                <SubmitButton label="На продажу" />
            </form>
        </Paper>
)}

const TradeContract = connect(
    null,
    dispatch => ({
        onTradeSubmit: (carId, data) =>
            agent.Clients.tradeSubmit(carId, data)
            .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
        onContractBankrupt: (contractId, isBankrupt) =>
            agent.Contract.bankrupt(contractId, isBankrupt)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract})),
    })
)(reduxForm({form: "trade-contract-form"})(tradeContract));

export default TradeContract;



// WEBPACK FOOTER //
// ./src/components/TradeContract.js